import React from 'react';
import { LabelProps } from 'typings';
import './styles.scss';

export const Label: React.FC<LabelProps> = props => {
    return (
        <bds-typo
            style={{ color: props.color ? props.color : '' }}
            variant={props.variant}
            bold={props.bold}
            margin={props.margin}
            class={props.className}
        >
            {props.children}
        </bds-typo>
    );
};
